import React, { useEffect, useState } from 'react';
import ModalStyled from '../ModalStyled/ModalStyled';
import { InputAdornment, Typography } from '@mui/material';
import InputStyled from '../InputStyled/InputStyled';
import { ButtonStyled } from '../ButtonStyled/ButtonStyled';
import { COLORS } from '../../constants/COLORS';
import { Spacing } from '../Spacing/Spacing';
import { formatReal, isEmptyObject, realToNumber } from '../../utils/objectManipulation';
import { PLANT_STATUS } from '../../constants/PLANT_STATUS';
import { Description, Price, Status } from './styled';
import { clearForm, getDataForm, isValidForm } from '../../utils/formController';
import { getColor } from '../../services/imageMapper';
import { ALERT_TYPES } from '../../constants/ALERT_TYPES';
import { changeEnterpriseStatus, saveEnterprisesAdmin } from '../../services/enterprisesAdmin';
import { createReservation } from '../../services/reservation';
import { useSnackbar } from 'notistack';
import { RESERVATION_STATUS } from '../../constants/RESERVATION_STATUS';
import AlertDialog from '../AlertDialog/AlertDialog';
import { USER_PERMISSION } from '../../constants/USER_PERMISSION';
import { currentUser, getAdminById } from '../../services/user';
import { createProposal } from '../../services/proposal';
import { sendEmail, sendPushNotification } from '../../services/notification';
import { getDataDocs } from '../../services/firestore';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { COLLECTION } from '../../constants/COLLECTION';
import { database } from '../../services/firebase';

const ModalAreaClient = ({ open, setOpen, enterprise, setArea, area, setIsProposal, isProposal }) => {
  const [form, setForm] = useState();
  const [showDialogReservation, setShowDialogReservation] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const findArea = () => {
    if (!isEmptyObject(form?.square.value)) {
      setArea(enterprise?.forms.find(item => item?.name === form?.square.value + form?.number.value));
    } else if (!isEmptyObject(area)) {
      setForm({ square: { value: area?.square }, number: { value: area?.number } });
    }
  };

  useEffect(() => {
    findArea();
  }, [open, form, enterprise, area]);

  const checkMaxReservation = async () => {
    const dataDocs = getDataDocs(
      await getDocs(query(collection(database, COLLECTION.RESERVATIONS), where('user', '==', currentUser()?.id)))
    );
    return Number(enterprise?.maxReservation) > dataDocs?.length && Number(enterprise?.maxReservation) !== 0;
  };

  const saveReservation = async () => {
    setIsLoading(true);
    if (isValidForm(form, setForm)) {
      if (await checkMaxReservation()) {
        setForm({ ...form, onSubmit: false });
        const newReservation = {
          ...getDataForm(form),
          enterprise: enterprise?.id,
          enterpriseName: enterprise?.name,
          status: RESERVATION_STATUS.RESERVED,
        };
        const newEnterprise = changeEnterpriseStatus(
          PLANT_STATUS.RESERVED,
          enterprise,
          form?.square.value + form?.number.value
        );
        const resId = (await createReservation(newReservation))[0]?.id;
        await saveEnterprisesAdmin(newEnterprise);
        enterprise.user.map(async user => {
          const admin = await getAdminById(user);
          sendEmail(
            admin?.email,
            'Nova Reserva!',
            'Olá, ' + admin?.name + '! Segue o link para acessar reserva.',
            window.location.origin + '/admin/reservas/' + resId
          );
          sendPushNotification(
            'Nova Reserva: ' +
              enterprise?.name +
              ' | lote ' +
              newReservation?.number +
              ' quadra ' +
              newReservation?.square,
            '',
            admin?.id,
            window.location.origin + '/admin/reservas/' + resId
          );
        });
        setShowDialogReservation(true);
        enqueueSnackbar('Reserva criada com sucesso.', { variant: ALERT_TYPES.SUCCESS });
      } else {
        enqueueSnackbar('Limite de reservas atingido.', { variant: ALERT_TYPES.WARNING });
      }
    } else {
      enqueueSnackbar('Dados inválidos.', { variant: ALERT_TYPES.WARNING });
    }
    setIsLoading(false);
  };

  const saveProposal = async () => {
    setIsLoading(true);
    if (isValidForm(form, setForm)) {
      setForm({ ...form, onSubmit: false });
      const data = getDataForm(form);
      const newProposal = {
        clientName: data.clientName,
        clientIdentification: data.clientIdentification,
        clientPhone: data.clientPhone,
        number: data.number,
        square: data.square,
        chat: [
          {
            message: 'R$' + data.price + ' - ' + data.description,
            sender: USER_PERMISSION.USER,
            date: new Date(),
            senderName: currentUser()?.name,
          },
        ],
        enterprise: enterprise?.id,
        enterpriseName: enterprise?.name,
      };
      const newEnterprise = changeEnterpriseStatus(
        PLANT_STATUS.IN_PROPOSAL,
        enterprise,
        form?.square.value + form?.number.value
      );
      const proId = (await createProposal(newProposal))[0]?.id;
      await saveEnterprisesAdmin(newEnterprise);
      enterprise.user.map(async user => {
        const admin = await getAdminById(user);
        sendEmail(
          admin?.email,
          'Nova Proposta!',
          'Olá, ' + admin?.name + '! Segue o link para acessar proposta.',
          window.location.origin + '/admin/propostas/' + proId
        );
        sendPushNotification(
          'Nova Proposta: ' + enterprise?.name + ' | lote ' + newProposal?.number + ' quadra ' + newProposal?.square,
          'R$' + data.price + ' - ' + data.description,
          admin?.id,
          window.location.origin + '/admin/propostas/' + proId
        );
      });
      setOpen(false);
      enqueueSnackbar('Proposta criada com sucesso.', { variant: ALERT_TYPES.SUCCESS });
    } else {
      enqueueSnackbar('Dados inválidos.', { variant: ALERT_TYPES.WARNING });
    }
    setIsLoading(false);
  };

  function getTitle() {
    return isProposal ? 'Nova Proposta' : 'Nova Reserva';
  }

  function getTitleByStatus() {
    return area?.status === PLANT_STATUS.AVAILABLE ? getTitle() : 'Ops, não está disponivel.';
  }

  return (
    <ModalStyled
      open={open}
      onClose={() => {
        setForm(clearForm(form));
        setArea({});
      }}
      setOpen={setOpen}
      title={!isEmptyObject(area) ? getTitleByStatus() : getTitle()}
    >
      <AlertDialog
        open={showDialogReservation}
        title={'Reserva confirmada!'}
        text={'Sua reserva de 24h foi realizada com sucesso.'}
        handleClose={() => setShowDialogReservation(false)}
        actions={
          <>
            <ButtonStyled
              onClick={() => {
                setShowDialogReservation(false);
                setOpen(false);
                setForm(clearForm(form));
                setArea({});
              }}
            >
              Ok
            </ButtonStyled>
          </>
        }
      />
      <Typography align={'left'} sx={{ width: '100%', marginBottom: '8px' }}>
        Lote
      </Typography>
      {!isEmptyObject(area) && (
        <>
          <Description>{area?.description}</Description>
          <Price>R$ {area?.price}</Price>
          <Status color={getColor(area?.status)}>{area?.status}</Status>
        </>
      )}
      <InputStyled
        mask={value => value?.toString().toUpperCase()}
        controller={{ form, setForm }}
        name={'square'}
        label={'Quadra'}
        type={'text'}
      />
      <InputStyled controller={{ form, setForm }} name={'number'} label={'Número'} type={'number'} />
      {(!(isEmptyObject(area) || area?.status !== PLANT_STATUS.AVAILABLE) || isProposal) && (
        <>
          <Typography align={'left'} sx={{ width: '100%', marginBottom: '8px' }}>
            Cliente
          </Typography>
          <InputStyled controller={{ form, setForm }} name={'clientName'} label={'Nome'} type={'text'} />
          <InputStyled
            onValidation={value =>
              String(value)
                .toLowerCase()
                .match(/\((\d{2})\)\s(\d{5})-(\d{4})/g) !== null && value.length === 15
            }
            messageValidation={'Celular inválido. Ex: (48) 99988-9988'}
            mask={value => {
              return (
                value &&
                value
                  .replace(/\D/g, '')
                  .replace(/(\d{2})(\d)/, '($1) $2')
                  .replace(/(\d{5})(\d{4})/, '$1-$2')
              );
            }}
            maxLength={15}
            controller={{ form, setForm }}
            name={'clientPhone'}
            label={'Teleforne'}
            type={'text'}
          />
          <InputStyled controller={{ form, setForm }} name={'clientIdentification'} label={'CPF'} type={'text'} />
        </>
      )}
      {isProposal && (
        <>
          <Typography align={'left'} sx={{ width: '100%', marginBottom: '8px' }}>
            Proposta
          </Typography>
          <InputStyled
            startAdornment={<InputAdornment position="start">R$</InputAdornment>}
            mask={value => value && formatReal(parseInt(value.toString().replace(/\D+/g, '')))}
            controller={{ form, setForm }}
            onValidation={value => realToNumber(value) >= realToNumber(area?.price)}
            messageValidation={'Valor mínimo de R$' + area?.price}
            name={'price'}
            label={'Valor'}
            type={'text'}
          />
          <InputStyled
            multiline
            controller={{ form, setForm }}
            name={'description'}
            label={'Nota de negociação'}
            type={'text'}
          />
        </>
      )}
      <Spacing width={'100%'} margin={'0 0 16px 0'} fd={'row'} jc={'flex-end'}>
        {!isProposal ? (
          <>
            <ButtonStyled
              disabled={isEmptyObject(area) || area?.status !== PLANT_STATUS.AVAILABLE || isLoading}
              margin={'0 0 0 auto'}
              bg={COLORS.YELLOW}
              colorText={COLORS.WHITE}
              onClick={() => setIsProposal(true)}
            >
              Fazer Proposta
            </ButtonStyled>
            <ButtonStyled
              disabled={isEmptyObject(area) || area?.status !== PLANT_STATUS.AVAILABLE || isLoading}
              margin={'0 0 0 16px'}
              bg={COLORS.GREEN_LIGHT}
              colorText={COLORS.WHITE}
              onClick={() => saveReservation()}
            >
              Reservar
            </ButtonStyled>
          </>
        ) : (
          <ButtonStyled
            disabled={isEmptyObject(area) || area?.status !== PLANT_STATUS.AVAILABLE || isLoading}
            margin={'0 0 0 16px'}
            bg={COLORS.GREEN_LIGHT}
            colorText={COLORS.WHITE}
            onClick={() => saveProposal()}
          >
            Enviar Proposta
          </ButtonStyled>
        )}
      </Spacing>
    </ModalStyled>
  );
};

export default ModalAreaClient;
